const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  list: {
    borderRadius: 5,
    listStyle: "none",
    backgroundColor: "#ffffff",
  },
});

export default styles;
